// ====================================================
// src/components/block/liveStreamManagement/enchainements/FonduEnchainement.ts
//
// Seul enchaînement implémenté pour l'instant : fondu enchaîné (crossfade)
// entre le flux "final" actuel et le flux "preview". Pas de réglage propre
// (la vitesse est portée par le T-bar lui-même, pas par l'enchaînement).
// ====================================================

import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface FonduConfig {}

class FonduEnchainementImpl extends Enchainement<FonduConfig> {
  readonly id = 'fondu';
  readonly label = 'Fondu';
  readonly icon = 'videoFadeTransition';
  readonly defaultConfig: FonduConfig = {};

  render(input: EnchainementRenderInput, _config: FonduConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress } = input;

    ctx.globalAlpha = 1;
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    if (progress > 0) {
      ctx.globalAlpha = progress;
      ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
      ctx.globalAlpha = 1;
    }
  }

  renderControls(_props: EnchainementControlProps<FonduConfig>) {
    return null;
  }
}

export const fonduEnchainement = new FonduEnchainementImpl();
